import SELandingCtrl from 'modules/writerassistant/landing/landing.controller';

const app = angular.module('app.writerassistant.landing', []);
app.controller('WriterAssistantLandingCtrl', SELandingCtrl);
export default app;

